export default __webpack_public_path__ + "static/media/image2vector.0e1c23fd.svg";